export default "__VITE_ASSET__Bdl3anAc__"